export default __webpack_public_path__ + "static/media/customer1.f03b25ac.png";